import { IHttpService, ITemplateCacheService, ITimeoutService, IWindowService } from "angular";
import { LogBookService } from "ng/src/app/core/services/logbook.service";
import { HALResponse } from 'ng/src/app/shared/model/app.model';
import { SystemParameter } from '../admin/src/app/system-parameters/system-parameters.model';
import { AppStateService } from "../ng/src/app/core/services/app-state.service";
import { LogBookRootScopeService } from "./shared/model/app.model";
import { NameDescSortIdLinks } from "./shared/model/properties.model";
import { IRouteEventRoute } from "./shared/model/route.model";
import { CookieService } from 'ngx-cookie-service';
import { NoteLocationMapComponent } from "ng/src/app/notes/shared/note-location-map/note-location-map.component";
import Quill from "quill";
import QuillImageDropAndPaste from 'quill-image-drop-and-paste';

angular.module('logbook')
	.run(['$rootScope', '$timeout', '$http', '$window', '$templateCache', 'appStateService', 'logBookService', 'cookieService', (
		$rootScope: LogBookRootScopeService,
		$timeout: ITimeoutService,
		$http: IHttpService,
		$window: IWindowService,
		$templateCache: ITemplateCacheService,
		appStateService: AppStateService,
		logBookService: LogBookService,
		cookieService : CookieService ) => {
		
			$rootScope.$on('$routeChangeSuccess', (event, current: IRouteEventRoute) => {
				$rootScope.title = current.$$route.title;
				$rootScope.tab = current.$$route.tab;

				$rootScope.mapRole = (role: NameDescSortIdLinks) => {
					if (role.id == 1)
						return 'READ';
					else if (role.id == 2)
						return 'WRITE';
					else if (role.id == 3)
						return 'ADMIN';

					return undefined;
					// throw 'Role not recognized';
				}
			});

			let hoverMQL = window.matchMedia('(hover: hover) and (pointer: fine)');

			hoverMQL.addListener(() => {
				$rootScope.hoverSupported = hoverMQL.matches;
			});
			
			$rootScope.hoverSupported = hoverMQL.matches;

			/**
			* Removes modal backdrops if there are no open modals found
			*/
			 let removeModalBackdrops = () => {
				$timeout(() => {
					try {
						// Check if any open modals exist
						if (!$('.modal.in').length) {
							// If not, remove the modal backdrop
							$(document.body).removeClass('modal-open');
							$('.modal-backdrop').remove();
						}
					}
					catch (e) {
						console.error(e);
					}
				})
			}
			
			$rootScope.$on('$routeChangeSuccess', removeModalBackdrops);
			$rootScope.$on('$routeUpdate', removeModalBackdrops);

			$http.get<HALResponse<{ systemParameters: SystemParameter[] }>>('api/systemParameters', {
				params: {
					'nameLike': ['appendToHead.%', 'configData.%'],
					'size': 10000,
					'sort': 'name'
				}
			})
			.then(response => {
				let hasVideoGuideInfo = false;
				response.data._embedded.systemParameters.forEach(parameter => {
					if (parameter.name.indexOf('appendToHead.') == 0)
						$('head').append(parameter.value);
					else if (parameter.name === SystemParameter.parameterNames.TUTORIAL_VIDEOS) {
						try {
							const res = JSON.parse(parameter.value);
							hasVideoGuideInfo = Array.isArray(res) && res.length > 0;
							if (!Array.isArray(res)) {
								console.error('Incorrect video guide information');
							}
						}
						catch (e) {
							console.error('Error parsing video guide information', e);
						}
					}
					else if (parameter.name.indexOf('configData.') == 0) {
						const key = parameter.name.substring('configData.'.length);

						try {
							logBookService.setConfigValue(key, JSON.parse(parameter.value));
						}
						catch(e) {
							console.log(e);
							
							logBookService.setConfigValue(key, parameter.value);
						}
					}
				});
				logBookService.setConfigValue('hasVideoGuides', hasVideoGuideInfo);
				appStateService.setClientTimeOffset(response.headers('Date'));
			});
		
			$templateCache.put('custom-pagination.html', require('./shared/controls/custom-pagination.html'));
			$templateCache.put('template-chart.html', require('./templates/charts/template-chart.html'));
			$templateCache.put('report-builder.html', require('./reports/report-builder/report-builder.html'));
			$templateCache.put('report-builder-starter.html', require('./reports/report-builder/report-builder-starter.html'));
			
			if( $window.location.search.indexOf('emailLoginOnly=true') >= 0 )
				cookieService.set('email-login-only', 'true');
				
			NoteLocationMapComponent.loadGoogleMapsAPI();
			Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);
			
			$rootScope.ngSpinnerRequests = 0;
		}
	]);